var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	5633: {
		fallback: () => (__webpack_require__.e(1547).then(() => (() => (__webpack_require__(91547))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.9.0 || ^0.10.0 || ^0.11.0 || ^0.12.0 || ^0.13.0 || ^14.0.0 || ^15.0.0 || ^16.0.0 || ^17.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "graphql",

	},
	56549: {
		fallback: () => (__webpack_require__.e(1547).then(() => (() => (__webpack_require__(91547))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.0.0 || ^16.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "graphql",

	},
	74629: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	26207: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0 <20.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	49069: {
		fallback: () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0 <20.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	54055: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	84655: {
		fallback: () => (__webpack_require__.e(1148).then(() => (() => (__webpack_require__(51148))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@bolt/foundations",

	},
	31187: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.2.0 <19",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	29445: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.2.0 <20.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	20212: {
		fallback: () => (__webpack_require__.e(804).then(() => (() => (__webpack_require__(38423))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.4.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/experience-context",

	},
	74505: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	78719: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0 || ^17.0.0 || ^18.0.0 || ^19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	70154: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	31815: {
		fallback: () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=16.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	52427: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	17968: {
		fallback: () => (__webpack_require__.e(8680).then(() => (() => (__webpack_require__(16299))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=1.51.0 <3.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@bolt/components",

	},
	83404: {
		fallback: () => (__webpack_require__.e(1148).then(() => (() => (__webpack_require__(51148))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=1.11.0 <3.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@bolt/foundations",

	},
	76782: {
		fallback: () => (__webpack_require__.e(2195).then(() => (() => (__webpack_require__(64576))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.100.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/commons",

	},
	262: {
		fallback: () => (__webpack_require__.e(2220).then(() => (() => (__webpack_require__(99839))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.15.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/utils",

	},
	36091: {
		fallback: () => (__webpack_require__.e(1148).then(() => (() => (__webpack_require__(51148))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.15.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@bolt/foundations",

	},
	54037: {
		fallback: () => (__webpack_require__.e(6758).then(() => (() => (__webpack_require__(16758))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.9.11",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@apollo/client",

	},
	84047: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0  || ^17 || ^18 || ^19 || ^19.0.0-rc",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	57705: {
		fallback: () => (__webpack_require__.e(6068).then(() => (() => (__webpack_require__(26068))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.2.7",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/navigation",

	},
	49519: {
		fallback: () => (__webpack_require__.e(1286).then(() => (() => (__webpack_require__(98905))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.6.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/i18n",

	},
	68764: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	90881: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8 || ^17.0 || ^18.0 || ^19.0 || ^19.0.0-rc",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	55023: {
		fallback: () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8 || ^17.0 || ^18.0 || ^19.0 || ^19.0.0-rc",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	69065: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.0 || ^17.0.0 || ^18.0.0 || ^19.0.0 || ^19.0.0-rc",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	80506: {
		fallback: () => (__webpack_require__.e(267).then(() => (() => (__webpack_require__(92648))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.30.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	91834: {
		fallback: () => (__webpack_require__.e(1537).then(() => (() => (__webpack_require__(16299))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.5.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@bolt/components",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"267": [
		31815
	],
	"961": [
		70154
	],
	"1537": [
		84655
	],
	"2195": [
		31187
	],
	"2220": [
		74505,
		78719
	],
	"2486": [
		90881,
		55023,
		69065
	],
	"2648": [
		31815,
		74505
	],
	"2740": [
		52427,
		76782,
		262,
		20212,
		29445,
		17968,
		83404,
		54055,
		36091,
		49519,
		54037
	],
	"3051": [
		90881,
		55023,
		69065
	],
	"3229": [
		52427,
		76782,
		262,
		20212,
		29445,
		17968,
		83404,
		54055,
		36091,
		54037,
		26207,
		49069,
		74505,
		78719,
		84047,
		57705,
		49519
	],
	"3687": [
		29445
	],
	"3913": [
		52427,
		29445,
		17968,
		83404,
		54055,
		20212
	],
	"4576": [
		31187,
		54055
	],
	"5483": [
		52427,
		76782,
		262,
		20212,
		29445,
		17968,
		83404,
		54055,
		36091,
		49519,
		26207,
		49069,
		54037,
		57705,
		74505,
		78719,
		68764,
		84047
	],
	"6262": [
		80506,
		91834
	],
	"6299": [
		26207,
		49069,
		54055,
		84655
	],
	"6758": [
		5633,
		56549,
		74629
	],
	"8423": [
		29445
	],
	"8680": [
		26207,
		49069,
		84655
	],
	"8905": [
		29445
	],
	"9327": [
		52427,
		29445,
		17968,
		83404,
		54055,
		20212
	],
	"9554": [
		52427,
		76782,
		262,
		20212,
		29445,
		17968,
		83404,
		54055,
		36091,
		54037,
		26207,
		49069,
		49519,
		84047
	],
	"9839": [
		20212,
		29445,
		54055,
		74505,
		78719
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}